import { useNavigate } from "react-router-dom";
import { broadcastCreateService } from "../utils/api";
import { notifyError, notifySuccess } from "../utils/notify";
import { DashboardLayout } from "./_common/DashboardLayout";
import { BoardcastForm } from "./components/BoardcastForm";

export function BroadcastCreate() {

    const navigate = useNavigate();

    return (
        <DashboardLayout route="/broadcast">
            <h1 className="text-4xl font-semibold">Create Broadcast</h1>

            <div className="mt-6">
                <div className="grid grid-cols-3 gap-4">
                    <div className="col-span-1">
                        <BoardcastForm 
                            initialData={{ name: '', forward_list: [] }}
                            onSubmit={(data) => {
                                broadcastCreateService(data, (data) => {
                                    if (data.success) {
                                        notifySuccess(data.message)
                                        navigate('/broadcast')
                                    } else {
                                        notifyError(data.message)
                                    }
                                })
                            }} 
                        />
                    </div>
                </div>
            </div>
        </DashboardLayout>
    )
}